import React, { useEffect, useState } from "react";
import HomeworkLayout from "../../homework/component/layout";
import LeftWidget from "../../homework/component/Rows/components/LeftWidget";
import style from "./reviewExam.module.scss";
import QuestDanxuan from "../../homework/component/Rows/components/QuestDanxuan";
import QuestZhuguan from "../../homework/component/Rows/components/QuestZhuguan";
import Header from "../../../components/Header";
import useRequest from "../../../utils/useRequest";
import _ from "underscore";
import QuestDuoxuan from "../../homework/component/Rows/components/QuestDuoxuan";
import { Button, message, Spin } from "antd";
import { getCorrectState } from "../../homework/component/Rows/utils";
import useFileDownload from "../../../utils/useFileDownload";
import {
    getExamInfo,
    getStudentExamPaperInfo,
    savePaperScore
} from "../../../service/exam";
import {
    errorMessage,
    getQuestionTypeName,
    QuestionType
} from "../../../service/service";
import QuestTianKong from "pages/homework/component/Rows/components/QuestTianKong";
import QuestCompound from "pages/homework/component/Rows/components/QuestCompound";
import RecordModal from "./component/RecordModal";
import useModalHandler from "utils/v2/useModalHandler";
import useRequestFn from "utils/useRequestFn";
import { useHistory } from "react-router-dom";
import { nanoid } from "nanoid";
import FilesList from "./component/FilesList";
import classNames from "classnames";

export interface UrlParams {
    paperId: string;
    studentId: string;
    examId: string;
    ban: string; //是否禁考
}

interface PageReviewExamProps {
    match: { params: UrlParams };
}

export interface Answer {
    answerId: number;
    content: string;
    isRight: "0" | "1";
    isChoose: "0" | "1";
    stuAnswer: string;
}

export interface Topic {
    topicId: number;
    type: QuestionType;
    typescript: string;
    trunk: string;
    score: string;
    markScore: string;
    contentText: string;
    isRight: "0" | "1";
    answers: Answer[];
    topics: Topic[];
    comment?: string;
}

export default function PageReviewExam({
    match: { params }
}: PageReviewExamProps) {
    const history = useHistory();
    const { examId, paperId, studentId } = params;
    const recordModal = useModalHandler(undefined, { remove: true });

    const [getExamPaperInfo, { loading, data }] = useRequestFn(
        getStudentExamPaperInfo
    );

    const [examInfo] = useRequest(() => getExamInfo(examId));

    const [courseName, setCourseName] = useState("");
    const [stuName, setStuName] = useState("");
    const [homeworkTime, setHomeworkTime] = useState("");
    const [paperName, setPaperName] = useState(""); //试卷名

    const [topicList, setTopicList] = useState<Topic[]>([]);

    const onQuestClick = useFileDownload(() => stuName);

    useEffect(() => {
        getExamPaperInfo({ paperId, studentId });
    }, []);

    useEffect(() => {
        if (!data || !examInfo) return;
        setCourseName(examInfo.name);
        setStuName(data.studentName);
        setHomeworkTime(data.endTime);
        setTopicList(_.sortBy(data.topics, "type"));
        setPaperName(data.paperName);
    }, [data, examInfo]);

    const handleChangeScore = (
        score: number,
        topicId: number,
        comment?: string
    ) => {
        savePaperScore({
            paperId: params.paperId,
            studentId: params.studentId,
            topicId,
            examId,
            comment,
            score
        })
            .then(res => message.success("打分成功！"))
            .catch(e => message.error(errorMessage(e)));
        setTopicList(
            _.map(topicList, item => {
                if (item.topicId === topicId) {
                    item.markScore = score.toString();
                    item.comment = comment;
                } else if (item.topics && item.topics.length > 0) {
                    item.topics = _.map(item.topics, topic => {
                        if (topic.topicId === topicId) {
                            topic.markScore = score.toString();
                            topic.comment = comment;
                        }
                        return topic;
                    });
                }
                return item;
            })
        );
    };

    const goPrev = () => {
        if (!data?.preStudent) return;
        const { paperId, studentId, studentNo, ban } = data.preStudent;
        getExamPaperInfo({ paperId, studentId });
        history.replace(
            `/exam/review/detail/${examId}/${paperId}/${studentId}/${studentNo}/${ban}`
        );
    };

    const goNext = () => {
        if (!data?.nextStudent) return;
        const { paperId, studentId, studentNo, ban } = data.nextStudent;
        getExamPaperInfo({ paperId, studentId });
        history.replace(
            `/exam/review/detail/${examId}/${paperId}/${studentId}/${studentNo}/${ban}`
        );
    };

    return (
        <div className={style.root}>
            <div className={style.printHide}>
                <Header />
            </div>

            <HomeworkLayout
                left={
                    <LeftWidget
                        courseName={courseName}
                        stuName={stuName}
                        homeworkTime={homeworkTime}
                        list={topicList}
                        paperName={paperName}
                    />
                }
                main={
                    <div onClick={onQuestClick} key={nanoid()}>
                        <Spin spinning={loading}>
                            {topicList.map((item, index) => (
                                <div key={item.topicId}>
                                    {item.type === QuestionType.DanXuan && (
                                        <div
                                            key={index}
                                            className={style.block}>
                                            <div className={style.header}>
                                                <b>
                                                    {getQuestionTypeName(
                                                        item.type
                                                    )}
                                                </b>
                                                (本小题 {item.score} 分)
                                            </div>
                                            <QuestDanxuan
                                                key={item.topicId}
                                                index={index}
                                                trunk={item.trunk}
                                                answers={item.answers}
                                                correct={getCorrectState(
                                                    item,
                                                    1
                                                )}
                                            />
                                        </div>
                                    )}
                                    {item.type === QuestionType.DuoXuan && (
                                        <div
                                            key={index}
                                            className={style.block}>
                                            <div className={style.header}>
                                                <b>
                                                    {getQuestionTypeName(
                                                        item.type
                                                    )}
                                                </b>
                                                (本小题 {item.score} 分)
                                            </div>
                                            <QuestDuoxuan
                                                key={item.topicId}
                                                index={index}
                                                trunk={item.trunk}
                                                answers={item.answers}
                                                correct={getCorrectState(
                                                    item,
                                                    1
                                                )}
                                            />
                                        </div>
                                    )}
                                    {item.type === QuestionType.PanDuan && (
                                        <div
                                            key={index}
                                            className={style.block}>
                                            <div className={style.header}>
                                                <b>
                                                    {getQuestionTypeName(
                                                        item.type
                                                    )}
                                                </b>
                                                (本小题 {item.score} 分)
                                            </div>
                                            <QuestDanxuan
                                                key={item.topicId}
                                                index={index}
                                                trunk={item.trunk}
                                                answers={item.answers}
                                                correct={getCorrectState(
                                                    item,
                                                    1
                                                )}
                                            />
                                        </div>
                                    )}
                                    {item.type === QuestionType.ZhuGuan && (
                                        <div
                                            key={index}
                                            className={style.block}>
                                            <QuestZhuguan
                                                comment={item.comment}
                                                onChange={handleChangeScore}
                                                index={index}
                                                topicId={item.topicId}
                                                contentText={item.contentText}
                                                answers={item.answers}
                                                trunk={item.trunk}
                                                markScore={item.markScore}
                                                score={item.score}
                                            />
                                        </div>
                                    )}

                                    {item.type === QuestionType.TianKong && (
                                        <div
                                            key={index}
                                            className={style.block}>
                                            <div className={style.header}>
                                                <b>
                                                    {getQuestionTypeName(
                                                        item.type
                                                    )}
                                                </b>
                                                (本小题 {item.score} 分)
                                            </div>
                                            <QuestTianKong
                                                key={item.topicId}
                                                index={index}
                                                trunk={item.trunk}
                                                answers={item.answers}
                                                correct={getCorrectState(
                                                    item,
                                                    1
                                                )}
                                            />
                                        </div>
                                    )}
                                    {item.type === QuestionType.TingLi && (
                                        <div
                                            key={index}
                                            className={style.block}>
                                            <div className={style.header}>
                                                <b>
                                                    {getQuestionTypeName(
                                                        item.type
                                                    )}
                                                </b>
                                                (本小题 {item.score} 分)
                                            </div>
                                            <QuestCompound
                                                key={item.topicId}
                                                index={index}
                                                trunk={item.trunk}
                                                topics={item.topics}
                                                onChange={handleChangeScore}
                                                correct={getCorrectState(
                                                    item,
                                                    1
                                                )}
                                            />
                                        </div>
                                    )}
                                    {item.type ===
                                        QuestionType.WanXingTianKong && (
                                        <div
                                            key={index}
                                            className={style.block}>
                                            <div className={style.header}>
                                                <b>
                                                    {getQuestionTypeName(
                                                        item.type
                                                    )}
                                                </b>
                                                (本小题 {item.score} 分)
                                            </div>
                                            <QuestCompound
                                                key={item.topicId}
                                                index={index}
                                                trunk={item.trunk}
                                                topics={item.topics}
                                                onChange={handleChangeScore}
                                                correct={getCorrectState(
                                                    item,
                                                    1
                                                )}
                                            />
                                        </div>
                                    )}
                                    {item.type === QuestionType.YueDuLiJie && (
                                        <div
                                            key={index}
                                            className={style.block}>
                                            <div className={style.header}>
                                                <b>
                                                    {getQuestionTypeName(
                                                        item.type
                                                    )}
                                                </b>
                                                (本小题 {item.score} 分)
                                            </div>
                                            <QuestCompound
                                                key={item.topicId}
                                                index={index}
                                                trunk={item.trunk}
                                                topics={item.topics}
                                                onChange={handleChangeScore}
                                                correct={getCorrectState(
                                                    item,
                                                    1
                                                )}
                                            />
                                        </div>
                                    )}
                                </div>
                            ))}

                            {!!data?.uploadFiles.length && (
                                <div className={style.files}>
                                    学生上传作答内容
                                    <FilesList list={data.uploadFiles} />
                                </div>
                            )}

                            <div
                                className={classNames(
                                    style.footer,
                                    style.printHide
                                )}>
                                <Button
                                    type="primary"
                                    onClick={() => window.history.back()}>
                                    返回
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={recordModal.open}>
                                    查看监考记录
                                </Button>
                                {!data?.preStudent && (
                                    <span className={style.firstStu}>
                                        当前是第一位学生
                                    </span>
                                )}
                                {data?.preStudent && (
                                    <Button
                                        className={style.btnPrev}
                                        onClick={goPrev}>
                                        上一份
                                    </Button>
                                )}
                                {data?.nextStudent && (
                                    <Button
                                        className={style.btnNext}
                                        onClick={goNext}>
                                        下一份
                                    </Button>
                                )}
                                {!data?.nextStudent && (
                                    <span className={style.lastStu}>
                                        当前是最后一位学生
                                    </span>
                                )}
                            </div>
                        </Spin>
                    </div>
                }
            />

            {recordModal.render(<RecordModal />)}
        </div>
    );
}
